import LatestPhones from './LatestPhones';

export default LatestPhones;
